import api from "../api/axios";

export const getEmployeeData = async (path) => {
  let userEmail = localStorage.getItem("user");
  let user = JSON.parse(userEmail);
  const email = user.email;
  console.log("user email is", email);

  const res = await api.post(`${path}`, { email });
  console.log("response from getEmployeeData -->", res);
  localStorage.setItem("employeeID", res?.data?.results?.employee_id);
  return res;
};

export const postData = async (path, data) => {
  const res = await api.post(`${path}`, data);
  console.log("policy response--->", res);
  return res;
};

export const getData = async (path) => {
  const res = await api.get(`${path}`);
  console.log("policy response--->", res);
  return res;
};
